/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class PreparedStatement {
  ID: number;
  HEADER: string;
  TEXT: string;
  REFS: FootNote[];
  FAVORITE: boolean;

  constructor(values: PreparedStatement = { ID: 0, HEADER: '', TEXT: '', REFS: [], FAVORITE: false }) {
    Object.assign(this, values);
  }

  static parseArray(json: any[]): PreparedStatement[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(new PreparedStatement(j));

    return arr;
  }
}

export class FootNote{
  ID: number;
  CODE: string;
  REFERENCE: string;

  constructor(){
    this.ID = 0;
    this.CODE = '';
    this.REFERENCE = '';
  }

  static parseArray(v: any): FootNote[] {
    let arr = [];
    if(v && v?.suggestions){
      for(let s of v.suggestions){
        let note: FootNote = new FootNote();
        note.ID = s.ID;
        note.CODE = s.CODE;
        note.REFERENCE = s.REFERENCE;
        arr.push(note);
      }
    }

    return arr;
  }
}

export class FootNoteRef{
  REFERENCE: string;
  constructor(){
    this.REFERENCE = '';
  }
}

